import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { ExportService } from "..";
import { ExportFormatType } from "../enumerations";
import { ClosestProviderReportModel } from "../exportModels";
import { NetworkAssessmentAnalysisType } from "@app/projects/enumerators";
import { SelectFormat } from "./filters";
import GenerateBody from "./generate-body";
import * as toast from "./toast";

interface ClosestProviderExportsProps extends RouteComponentProps<unknown> {
  projectId: number;
  projectUrl: string;
  regionSetIds: number[];
  runConfigurationId: number;
  networkAssessmentAnalysisType: NetworkAssessmentAnalysisType;
}

const ClosestProviderExportsPanelBody: React.FC<React.PropsWithChildren<ClosestProviderExportsProps>> = (props: ClosestProviderExportsProps & { children: React.ReactNode }) => {
  const [reportName, setReportName] = React.useState<string>("Closest Providers to Members");
  const [emailOnSuccess, setEmailOnSuccess] = React.useState<boolean>(true);
  const [disabled, setDisabled] = React.useState<boolean>(false);
  const [fileFormat, setFileFormat] = React.useState<ExportFormatType>(ExportFormatType.CSV);
  const [sharedUsers, setSharedUsers] = React.useState<number[]>([]);

  const handleReportNameChange = (newName: string) => {
    setReportName(newName);
    setDisabled(false);
  };

  const updateSharedUsers = (sharedUsers: number[]) => {
    setSharedUsers(sharedUsers);
  }

  const handleEmailOnSuccessChange = (shouldEmail: boolean) => {
    setEmailOnSuccess(shouldEmail);
    setDisabled(false);
  };

  const handleGenerateClick = async () => {
    setDisabled(true);

    const requestModel: ClosestProviderReportModel = {
      customProjectId: props.projectId,
      eMailOnSuccess: emailOnSuccess,
      exportName: reportName,
      formatType: fileFormat,
      networkAssessmentAnalysisType: props.networkAssessmentAnalysisType,
      projectRunConfigurationId: props.runConfigurationId,
      projectUrl: props.projectUrl,
      regionSetIds: props.regionSetIds,
      runAsynchronous: true,
      sharedUsers: sharedUsers
    };

    const exportService = new ExportService();
    exportService.postExportClosestProvider(requestModel).then(() => {
      toast.toastInfo(reportName);
      setDisabled(true);
    });
  };

  const handleFormatChange = (newFormat: ExportFormatType) => {
    setFileFormat(newFormat);
  };

  return (
    <>
      <div className="col-4">
        <SelectFormat
          availableExportFormats={[ExportFormatType.CSV, ExportFormatType.Pipe, ExportFormatType.Tab]}
          excelDisabled={false}
          exportType="closest-providers"
          onOutputFormatChange={handleFormatChange}
          outputFormat={fileFormat}
        />
      </div>
      <GenerateBody
        {...props}
        emailOnSuccess={emailOnSuccess}
        reportName={reportName}
        onGenerateClick={handleGenerateClick}
        onEmailOnSuccessChange={handleEmailOnSuccessChange}
        onReportNameChange={handleReportNameChange}
        isLoading={disabled}
        isValid={reportName.length > 0 && reportName.length < 255}
        showSharedUsers={true}
        sharedUsers={sharedUsers}
        updateSelectedSharedUsers={updateSharedUsers}
        exportType="ClosestProvidersToMembers"
        projectId={props.projectId}
        networkAssessmentAnalysisType={props.networkAssessmentAnalysisType}
      />
    </>
  );
};

export default ClosestProviderExportsPanelBody;
